import { useQuery, ApolloError } from '@apollo/client';
import { useMemo, useEffect, useRef } from 'react';
import { useAppStateContext } from 'src/auth/AppStateContext';
import FETCH_NOTIFICATIONS_LIST from 'src/graphql/query/notificationList';
import { INotification } from 'src/types';

interface UseQueryListNotificationResult {
  notificationList: INotification[];
  loading: boolean;
  refetch: () => void;
  error: ApolloError | undefined;
}

const useQueryListNotification = (skip: number, userId: string): UseQueryListNotificationResult => {
  const { setNotifications } = useAppStateContext();
  const prevNotificationList = useRef<INotification[] | null>(null);

  const { data, loading, refetch, error } = useQuery(FETCH_NOTIFICATIONS_LIST, {
    variables: {
      skip,
      userId,
    },
    fetchPolicy: "cache-first",
    pollInterval: 30000,
  });

  const notificationList = useMemo(() => {
    return (data?.notificationList || []) as INotification[];
  }, [data]);

  useEffect(() => {
    if (notificationList !== prevNotificationList.current) {
      setNotifications(notificationList);
      prevNotificationList.current = notificationList;
    }
  }, [notificationList, setNotifications]);

  return { notificationList, loading, refetch, error };
};

export default useQueryListNotification;